"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("../../styles");
var getMargin = function (spacing, margin) { return (typeof margin === 'number' ? spacing(margin) : undefined); };
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            marginTop: function (_a) {
                var _b = _a.margin, margin = _b === void 0 ? {} : _b;
                return getMargin(spacing, margin.top);
            },
            marginRight: function (_a) {
                var _b = _a.margin, margin = _b === void 0 ? {} : _b;
                return getMargin(spacing, margin.right);
            },
            marginBottom: function (_a) {
                var _b = _a.margin, margin = _b === void 0 ? {} : _b;
                return getMargin(spacing, margin.bottom);
            },
            marginLeft: function (_a) {
                var _b = _a.margin, margin = _b === void 0 ? {} : _b;
                return getMargin(spacing, margin.left);
            }
        }
    });
});
exports.default = useStyles;
